// Tabla «antes → después» de un renombre de menú, plegada por defecto.
// Complementa a AvisoRenombre: aquel avisa en la pantalla donde el usuario
// aterrizó; esta es la referencia completa, en la Ayuda del módulo, para quien
// busca una opción que ya no encuentra por su nombre viejo.
//
// Se usó primero en Financiero (script 745) y ahora también en Control Bancario
// y Contabilidad (script 757). Al retirar el aviso, retirar también esta tabla.
import { useState } from 'react';
import { BookOpen } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card';

export interface Renombre { antes: string; ahora: string; donde: string }

export function RenombresMenu({ filas, nota }: { filas: Renombre[]; nota: string }) {
  const [abierto, setAbierto] = useState(false);
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2 text-base">
          <BookOpen className="h-5 w-5 text-primary" /> El menú cambió de nombres
          <button className="ml-auto text-sm font-normal text-primary hover:underline"
            onClick={() => setAbierto((v) => !v)}>
            {abierto ? 'Ocultar' : 'Ver qué se llama ahora cómo'}
          </button>
        </CardTitle>
      </CardHeader>
      {abierto && (
        <CardContent>
          <p className="mb-3 text-xs text-muted-foreground">{nota}</p>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b text-xs text-muted-foreground">
                  <th className="py-2 pr-3 text-left">Antes</th>
                  <th className="py-2 pr-3 text-left">Ahora</th>
                  <th className="py-2 text-left">Dónde</th>
                </tr>
              </thead>
              <tbody>
                {filas.map((r, i) => (
                  <tr key={i} className="border-b last:border-0">
                    <td className="py-2 pr-3 text-muted-foreground line-through">{r.antes}</td>
                    <td className="py-2 pr-3 font-medium">{r.ahora}</td>
                    <td className="py-2 text-muted-foreground">{r.donde}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </CardContent>
      )}
    </Card>
  );
}
